<template>
  <div style="height: 3.2rem;">
    <div id='logintitle'>
      <div class="right_div is_all_title">
        <div v-for='(item,inds) in leftlist' :key='inds + "0723"' class="imgpx" @click='handitem(inds)'>
          <a-popover v-if='inds == 3' v-model="visible" placement="bottom" :destroyTooltipOnHide="true" trigger="click"
            :overlayStyle="{width:'calc(9rem + 32px)'}"
            :getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
            <template slot="content">
              <img :src="require('@/image/home_model/lang.png')" alt="" style="width: 9rem;margin: 0;"
                @click='visible=true'>
              <center style="text-align: center;font-size: 16px;">{{$lang.qmiswx}}</center>
            </template>
            <img :src="item.imgurl" alt="" :class='inds == 1?"met":""' style='cursor:pointer'>
          </a-popover>
          <img :src="item.imgurl" alt="" :class='inds == 1?"met":""' v-if='inds<3' style='cursor:pointer'>
          <span style="position: relative;left: 10px;color: #b5b5b5;">{{leftlist.length>inds+1?'|':''}}</span>
        </div>
      </div>
      <div class='tit_heard'>
        <!-- <div><img :src="require('@/image/home_model/logo.png')" alt="" @click='handclick' style="width: 10rem;margin-left: 1rem;"></div>
        <div v-if="show" style="display: flex;justify-content: center;align-items: center;height: 3rem;">
          <a-icon type="close" style='font-size: 1.7rem;' @click='show = !show'/>
        </div>
        <div v-else style="display: flex;justify-content: space-between;align-items: center;width: 3.5rem;">
          <img :src="require('@/image/home_model/seach.png')" alt="" style="width: 1.2rem;cursor: pointer;">
          <img :src="require('@/image/home_model/meuo.png')" alt="" style="width: 1.2rem;cursor: pointer;"
          @click='show = true'>
        </div> -->
        <div>
          <img :src="require('@/image/home_model/meuo.png')" alt="" style="width: 1.2rem;cursor: pointer;"
          @click='show = true'>
          <img :src="require('@/image/home_model/logo.png')" alt="" @click='handclick'
           style="width: 9rem;margin-left: .8rem;"></div>
          <div style="display: flex;align-items: center;">
            <div class='hopen' @click='hopen' v-if="loginOpen">
              <img :src="require('@/image/meunleft/logo.png')" alt="" > {{$lang.cn_login}}</div>
          </div>
      </div>
      <handitem v-if='ishand' @child='handback'></handitem>
    </div>
    <modeltabLogin :shouyelist='shouyelist' :ismodeltab='show' @child='show=false'></modeltabLogin>
  </div>
</template>

<script>
  import handitem from './handitem.vue'
  import modeltabLogin from '../modeltab/mod_right.vue'
  // modeltab_login.vue'

  export default {
    props: ['gonum', 'handnum'],
    components: {
      handitem,modeltabLogin
    },
    data() {
      return {
        loginOpen:true,
        onlinestate:sessionStorage['onlinestate'],
        visible: false,
        shShowBol: false,
        iskey: {
          // name:'EN >',
          // url:require('@/image/new/EN.png')
        },
        langage: [{
          name: 'EN',
          url: require('@/image/new/EN.png')
        }, {
          name: '中文',
          url: require('@/image/new/CN.png')
        }],
        show: false, //动画
        ishand: false,
        islang: window.localStorage.guanwanglang,
        islink: 0,
        leftlist: [{
          imgurl: require('@/image/home_model/lang.png'),
          name: '中文 >',
          en_name: 'EN >'
        }, {
          imgurl: require('@/image/home_model/yuyue.png'),
          name: '預約開戶',
          en_name: 'Online Account Opening'
        }, {
          imgurl: require('@/image/home_model/joinwe.png'),
          name: '加入我們',
          en_name: 'Join Us'
        }, {
          imgurl: require('@/image/home_model/wx1.png'),
          name: '微信公眾平台',
          en_name: 'Offcial'
        }],
        shouyelist: [{
            imgurl: require('@/image/meunleft/home.png'),
            name: '首頁',
            en_name: 'Home',
            url: '/'
          },
          {
            imgurl: require('@/image/meunleft/chanqi.png'),
            imgurl1: require('@/image/meunleft/chanqi1.png'),
            name: '產品及服務',
            en_name: 'Products & Services',
            url: '/products&services'
          },
          {
            imgurl: require('@/image/meunleft/xingu.png'),
            name:this.$lang.xgrg,
            en_name: this.$lang.xgrg,
            url: '/ipo_subscriptions'
          },
          {
            imgurl: require('@/image/meunleft/kehu.png'),
            imgurl1: require('@/image/meunleft/kehu1.png'),
            name: '客戶服務',
            en_name: 'Customer Services',
            url: '/apply-in-person'
          },
          {
            imgurl: require('@/image/meunleft/yuyue.png'),
            name: '預約開戶',
            en_name: 'Make Appointment',
            // url: 'https://hk.iqmis.com/accopen/main/Officialwebsite?lang='
            // url: 'http://120.79.92.205/webkh/main/Officialwebsite?lang='
            url: '/account_opening_appointment'
          },
          // {
          //   imgurl: require('@/image/meunleft/wangsha.png'),
          //   name: '網上開戶',
          //   en_name: 'Online Account Opening',
          //   url: 'https://hk.qmisit.com/accopen/?lang='
          // },
          {
            imgurl: require('@/image/meunleft/wangsha.png'),
            name: '在線開戶',
            en_name: 'Account Opening',
            url: 'https://hk.qmisit.com/accopen/?lang='
          },
          {
            imgurl: require('@/image/meunleft/aboutus.png'),
            name: '關於我們',
            en_name: 'About Us',
            url: '/about_us'
          },
          {
            imgurl: require('@/image/meunleft/lianxi.png'),
            name: '聯絡我們',
            en_name: 'Contact Us',
            url: '/contact_us'
          },
        ]
      }
    },
    mounted() {
      if (this.handnum) {
        this.islink = this.handnum
      }
      if (this.islang == 'eng') {
        this.iskey = this.langage[0]
      } else {
        this.iskey = this.langage[1]
      }
      if(this.onlinestate == 'ipad'){
        if (this.islang == 'eng') {
          this.shouyelist[5]['url'] = 'https://apps.apple.com/cn/app/%E8%8F%AF%E4%BA%9E%E8%AD%89%E5%88%B8%E4%BA%A4%E6%98%93/id1604111255'
        } else {
          this.shouyelist[5]['url'] = 'https://apps.apple.com/cn/app/%E8%8F%AF%E4%BA%9E%E8%AD%89%E5%88%B8%E4%BA%A4%E6%98%93/id1604111255'
        }
      }
      this.loginFlag()
    },
    methods: {
      loginFlag(){
        this.$ajax({
          method:'post',
          url:this.$api.getSwitchStatus
        }).then(res=>{
          if(res.data.code === 1000){
            this.loginOpen = res.data.data.switchStatus
          }else{
            this.$message.warning(res.data.message)
          }
        })
      },
      wangshangjiaoyi(){
        this.$ajax({
          method:'post',
          url:this.$api.wangshangjiaoyi
        }).then(res=>{
          if(res.data.qmiscode === 1000){
          }else{
            this.$message.warning(res.data.qmismsg)
          }
        })
      },
      hopen(){
        this.wangshangjiaoyi()
        window.open('https://iglobal.qmis.com.hk/mts.web/Web2/login/qmis/index.html#' + this.islang)
      },
      showstran() {
        this.show = !this.show
      },
      handleMenuClick(val) {
        console.log(val)
        // this.iskey = this.langage[val.key]
        // let num =  this.iskey.name == 'EN'? 1:0;
        this.iskey = val
        // if(i== 0){
        if (val.name == 'EN') {
          // window.localStorage.guanwanglang = ''
          window.localStorage.guanwanglang = 'eng'
        } else {
          // window.localStorage.guanwanglang = ''
          window.localStorage.guanwanglang = 'big5'
        }
        setTimeout(() => {
          // location.reload();
          location.href = location.href.split('?lang=')[0]
        }, 200)
        // }
      },
      handback() {
        this.ishand = false
      },
      handitem(i) {
        let arr = ['', 'https://hk.iqmis.com/accopen/main/Officialwebsite?lang=', '/contact_us',
          'https://hk.qmisit.com/accopen/?lang=',
        ]
        if (i == 1) {
          window.open(arr[i] + this.islang)
        }
        if (i == 2) {
          this.postdata();
          this.$router.push('/join_us')
        }
        if (i == 3) {
          // this.ishand = true
          this.shShowBol = true
        }

      },
      handlink(i) {
        this.islink = i
        if (i == 1) {
          this.$emit('child', 1)
          this.$router.push({
            path: this.shouyelist[i]['url'],
            query: {
              isdiv: '1'
            }
          })
        } else if (i == 2) {
          // return
          window.open(this.shouyelist[i]['url'] + window.localStorage.guanwanglang)
        } else if (this.shouyelist[i]['url']) {
          this.$router.push(this.shouyelist[i]['url'])
        }
      },
      handclick() {
        // console.log()
        // let str = location.protocol+location.host+'/qmisgroup'
        // window.location.href = 'http://120.79.92.205/qmisgroup'
        // this.$router.go(this.gonum)
        if(location.hostname == 'qmisgroup.com'){
          window.location.href = 'http://www.qmisgroup.com/'
        }else{
          this.$router.push('/')
          setTimeout(() => {
            window.location.reload();
          }, 500);
          // window.location.href = 'http://120.79.92.205/qmisgroup'
        }
      }
    }
  }
</script>


<style scoped lang="less">

  #logintitle{
    position: fixed;
    top: 0;
    z-index: 100;
    width: 100%;
  }

  #logintitle .seachinput {
    width: calc(97%) !important;
    display: inline-block;
    border: 0;
    padding: 6px 0;
    border-bottom: 1px solid #d5d3d3;
  }

  #logintitle .seachinput::-webkit-input-placeholder {
    font-size: 18px;
      }

  #logintitle .ant-popover-inner-content {
    padding: .2rem !important;
  }

  #logintitle .tit_heard {
    z-index: 100;
    display: flex;
    justify-content: space-between;
    box-shadow: 0 0 5px #888888;
    background: #f5f5f5;
    padding: .2rem 1rem;
  }

  #logintitle .right_div {
    margin: 0rem;
    background-color: #09666e;
    color: #fff;
    padding: 0 .2rem;
    text-align: right;

    div {
      padding: 0 .7rem;
      display: inline-block;
      text-align: right;
      font-size: 16px;
    }
  }

  #logintitle .login-title {
    font-size: 6rem;
    font-weight: 500;
    letter-spacing: 15px;
    color: #FFF;
    padding-top: 5rem;
    text-align: center;
  }

  #logintitle .imgpx img {
    width: 1rem;
    margin: .5rem 0 .4rem;
    position: relative;
    top: -.1rem;
    // position: relative;
    // line-height: .6rem;
    // vertical-align: bottom;
    // bottom: -.1rem;
  }

  .warp_right {
    position: relative;
    top: 1.2rem;
  }

  .warp_right div {
    display: inline-block;
    font-size: 16px;
    color: #333;
    // width: 4rem;
    padding: 0;
    // margin: 1.2rem 1rem;
    margin: 0 1rem;
  }

  .hovelink {
    border-bottom: 2px solid #09666e;
    color: #09666e !important;
    font-weight: 600;
  }

  .desktop-search-collapsible {
    padding: 8px 0;
    text-align: center;
  }

  .fa-search {
    margin: 0 8px;
    font-size: 18px ;
       color: #5f5d5d;
    border: 0;
    background: transparent;
    cursor: pointer;
    font-family: 'Font Awesome 5 Pro';
    font-weight: 900;
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
  }
  .hopen{
    background-color: #09666E;color: #fff;border-radius: 6px;padding: 8px 4px;font-size: 13px;font-weight: 600;
  }
  .hopen img{
    width: 15px;
  }
  @media screen and (max-width: 1100px) {
    .myspan {
      display: none;
    }

    #logintitle .imgpx img {
      width: 2rem;
      margin: .5rem;
    }

    .warp_right {
      display: none;
    }
    .hopen{
     font-size: 16px;
    }
    .hopen img{
      width: 20px;
    }
  }
  @media screen and (max-width: 600px){
    .hopen{
      background-color: #09666E;color: #fff;border-radius: 6px;padding: 8px 4px;font-size: 13px;
    }
    .hopen img{
      width: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login/login_model.vue